import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';


// Vendors
// NGX component
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { UiSwitchModule } from 'ngx-ui-switch';
/* import { SelectDropDownModule } from 'ngx-select-dropdown'; */
import { QuillModule } from 'ngx-quill';
import { NgxIntlTelInputModule } from '@khazii/ngx-intl-tel-input';

import { QRCodeModule } from 'angularx-qrcode';

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

// Bootstrap component
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Components
import { CodeInputComponent } from '@components/code-input/code-input.component';
import { ImgRoundComponent } from '@components/img-round/img-round.component';
import { PoweredByGiviComponent } from '@components/powered-by-givi/powered-by-givi.component';
import { PhoneInputComponent } from '@components/phone-input/phone-input.component';
import { AccountRegisterFormComponent } from '@components/account-register-form/account-register-form.component';
import { GoogleSigninCardComponent } from '@components/google-signin-card/google-signin-card.component';
import { AccountOtpVerifyComponent } from '@components/account-otp-verify/account-otp-verify.component';
import { SearchFilterComponent } from '@components/search-filter/search-filter.component';
import { PlayScratchComponent } from '@components/play-scratch/play-scratch.component';
import { ScratchBoxComponent } from '@components/play-scratch/scratch-box.component';
import { LuckyScratchLayoutComponent } from '@components/lucky-scratch/lucky-scratch-layout.component';
import { LuckyScratchBoxComponent } from '@components/lucky-scratch/lucky-scratch-box.component';
import { LuckyPrizesPanelComponent } from '@components/lucky-scratch/lucky-prizes-panel.component';
// list vertical
import { SmartListStoreComponent } from '@components/smart-list-store/smart-list-store.component';
import { SmartListStoreWebComponent } from '@components/smart-list-store-web/smart-list-store-web.component';
import { SmartListUserPointComponent } from '@components/smart-list-user-point/smart-list-user-point.component';
import { SmartListUserTransactionComponent } from '@components/smart-list-user-transaction/smart-list-user-transaction.component';
import { SmartListUserTransactionFilterComponent } from '@components/smart-list-user-transaction/smart-list-user-transaction-filter.component';

//Givi scan app components
import { GsaAccountInfoComponent } from '@components/gsa-account-info/gsa-account-info.component';
import { GsaGiviSkuModalComponent } from '@components/gsa-givi-sku-modal/gsa-givi-sku-modal.component';

import { SpinnerComponent } from '@components/spinner/spinner.component';
import { UserNavProfileComponent } from '@components/user-profile/user-nav-profile.component';
// import { TransfersTermsConditionsComponent } from '@components/transfers-terms-conditions/transfers-terms-conditions.component';

// Directives
import { InputFloatDirective } from './directives/input-float.directive';
import { InputNumericDirective } from './directives/input-numeric.directive';

// Modals
import { AcceptGiviModalComponent } from '@components/accept-givi-modal/accept-givi-modal.component';
import { GiviExpressModalComponent } from '../components/givi-express-modal/givi-express-modal.component';
import { AssignedGiviModalComponent } from '@components/assigned-givi-modal/assigned-givi-modal.component';

import { PurchaseWithPointsModalComponent } from '@components/purchase-with-points/purchase-with-points-modal.component';
import { PurchaseGiftcardModalComponent } from '@components/purchase-giftcard/purchase-giftcard-modal.component';
import { PurchaseProductModalComponent } from '@components/purchase-product/purchase-product-modal.component';
import { PurchasePointsModalComponent } from '@components/purchase-points/purchase-points-modal.component';
import { PurchaseTicketModalComponent } from '@components/purchase-ticket/purchase-ticket-modal.component';

import { LoginModalComponent } from '@components/login-modal/login-modal.component';
import { SendGiviComponent } from '@components/send-givi/send-givi.component';
import { SendGiviLinkComponent } from '@components/send-givi/send-givi-link.component';
import { SendGiviSmsComponent } from '@components/send-givi/send-givi-sms.component';
import { SendPackageSmsComponent } from '@components/send-package/send-package-sms.component';
import { SendGiviModalComponent } from '@components/send-givi/send-givi-modal.component';
import { GeneralVideoModalComponent } from '@components/general-video-modal/general-video-modal.component';
import { GiviNoteModalComponent } from '@components/givi-note-modal/givi-note-modal.component';
import { GetPointsModalComponent } from '@components/get-points-modal/get-points-modal.component';
import { PackageBenefitDetailModalComponent } from '@components/package-benefit-detail-modal/package-benefit-detail-modal.component';
import { PurchasePackageModalComponent } from '@components/purchase-package-modal/purchase-package-modal.component';
import { CompleteRegisterAppComponent } from '@components/complete-register-app/complete-register-app.component';
import { DeleteTransactionComponent } from '@components/delete-transaction/delete-transaction.component';
import { TestModalComponent } from '@components/test-modal/test-modal.component';

import { RedeemedSuccessComponent } from '@components/redeemed-success/redeemed-success.component';
import { AssignedStickerComponent } from '@components/assigned-sticker/assigned-sticker.component';

import { VerifyCardComponent } from '@components/verify-card/verify-card.component';
import { VerifyAccountModalComponent } from '@components/verify-account-modal/verify-account-modal.component';

import { CommunityFormComponent } from '@components/community-form/community-form.component';

// Send package
import { SendPackageComponent } from '@components/send-package/send-package.component';
import { SendPackageLinkComponent } from '@components/send-package/send-package-link.component';


// Apis
import { ApiAuthService } from '@services/api-auth.service';
import { ApiBaseService } from '@services/api-base.service';
import { ApiAccountService } from '@services/api-account.service';
import { ApiPaymentGatewayService } from '@services/api-payment-gateway.service';
import { ApiCustomerService } from '@services/api-customer.service';
import { ApiTransactionService } from '@services/api-transaction.service';
import { ApiUploadService } from '@services/api-upload.service';
import { ApiProductService } from '@services/api-product.service';
import { ApiMarketService } from '@services/api-market.service';
import { ApiCommunityService } from '@services/api-community.service';
import { ApiPackageService } from '@services/api-package.service';
import { ApiLoyaltyPlanService } from '@services/api-loyalty-plans.service';
import { ApiScratchService } from '@services/api-scratch.service';
import { ApiVendorFormService } from '@services/api-vendor-form.service';

// Services
import { SharedService } from '@services/shared.service';

import { ComponentBase } from './component-base.component';
import { PageBase } from './page-base.component';

import { TicketsSelectorComponent } from '@components/tickets-selector/tickets-selector.component';
import { MarketTicketQuantityComponent } from 'app/pages/market/products/tickets/market-ticket-quantity.component';

//register 
import { RegisterAccountComponent } from '../register/register/register-account.component';
import { RegisterNewComponent } from '../register/register/register-new.component';
//register form
import { RegisterAccountFormComponent } from '../register/register/form/register-account-form.component';
import { RegisterNewFormComponent } from '../register/register/form/register-new-form.component';

//lobbys
import { PanamaLobbyComponent } from '@components/lobbys/panama-lobby/panama-lobby.component';
import { CostaRicaLobbyComponent } from '@components/lobbys/costa-rica-lobby/costa-rica-lobby.component';
import { GiviScannerComponent } from 'app/pages/givi-scanner/givi-scanner.component';

import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { WebcamModule } from 'ngx-webcam';

//pipes
import { TruncatePipe } from 'app/truncate.pipe';

import { VerifyPhoneFormComponent } from '@components/verify-account-modal/form/verify-phone-form.component';
import { VerifyEmailFormComponent } from '@components/verify-account-modal/form/verify-email-form.component';
import { PaymentMethodComponent } from '@components/payment-method/payment-method.component';
import { StripeCardComponent } from '@components/stripe-card/stripe-card.component';
import { CardFormComponent } from '@components/card-form/card-form.component';

//givis details
import { PackDetailsComponent } from '@components/givis-details/pack-details.component';
import { PopDetailsComponent } from '@components/givis-details/pop-details.component';
import { EventsDetailsComponent } from '@components/givis-details/events-details.component';
import { CouponDetailsComponent } from '@components/givis-details/coupon-details.component';

import { AssignedGiviComponent } from '@components/assigned-givi/assigned-givi.component';
import { SmartListCommunityVendorComponent } from '@components/smart-list-community-vendor/smart-list-community-vendor.component';
import { PurchaseCouponComponent } from '@components/purchase-coupon/purchase-coupon.component';
import { CouponQuantityComponent } from 'app/pages/coupons/coupon-quantity.component';


@NgModule({
    // components for use in THIS module
    declarations: [
        // Components
        CodeInputComponent,
        ImgRoundComponent,
        PoweredByGiviComponent,
        PhoneInputComponent,
        AccountRegisterFormComponent,
        GoogleSigninCardComponent,
        AccountOtpVerifyComponent,
        SearchFilterComponent,
        PlayScratchComponent,
        ScratchBoxComponent,
        LuckyScratchLayoutComponent,
        LuckyScratchBoxComponent,
        LuckyPrizesPanelComponent,
        TicketsSelectorComponent,
        MarketTicketQuantityComponent,

        // list vertical
        SmartListStoreComponent,
        SmartListStoreWebComponent,
        SmartListUserPointComponent,
        SmartListUserTransactionComponent,
        SmartListUserTransactionFilterComponent,

        SpinnerComponent,
        UserNavProfileComponent,
        //gsa components
        GsaAccountInfoComponent,
        GsaGiviSkuModalComponent,

        // TermsConditionsComponent,
        // TermsConditionsPromosComponent

        // Directives
        InputFloatDirective,
        InputNumericDirective,
        // Modals
        AcceptGiviModalComponent,
        GiviExpressModalComponent,
        AssignedGiviModalComponent,
        LoginModalComponent,
        PurchaseWithPointsModalComponent,
        PurchaseGiftcardModalComponent,
        PurchaseProductModalComponent,
        PurchasePointsModalComponent,
        PurchaseTicketModalComponent,
        SendGiviComponent,
        SendGiviLinkComponent,
        SendGiviSmsComponent,
        SendPackageSmsComponent,
        SendGiviModalComponent,
        GeneralVideoModalComponent,
        GetPointsModalComponent,
        GiviNoteModalComponent,
        RedeemedSuccessComponent,
        AssignedStickerComponent,
        VerifyCardComponent,
        PackageBenefitDetailModalComponent,
        PurchasePackageModalComponent,
        CompleteRegisterAppComponent,
        VerifyAccountModalComponent,
        CommunityFormComponent,
        SendPackageComponent,
        SendPackageLinkComponent,
        DeleteTransactionComponent,
        TestModalComponent,
        //register
        RegisterAccountComponent,
        RegisterNewComponent,
        //forms
        RegisterAccountFormComponent,
        RegisterNewFormComponent,
        PanamaLobbyComponent,
        CostaRicaLobbyComponent,
        GiviScannerComponent,
        VerifyPhoneFormComponent,
        VerifyEmailFormComponent,
        PaymentMethodComponent,
        StripeCardComponent,
        CardFormComponent,
        PackDetailsComponent,
        PopDetailsComponent,
        EventsDetailsComponent,
        CouponDetailsComponent,
        AssignedGiviComponent,
        SmartListCommunityVendorComponent,
        PurchaseCouponComponent,
        CouponQuantityComponent,
        TruncatePipe,

    ],
    imports: [
        // Common
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // QR
        ZXingScannerModule,
        WebcamModule,
        RouterModule,
        // Vendors
        AlertModule.forRoot(),
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        QuillModule.forRoot(),
        NgbModule,
        ScrollingModule,
        /* SelectDropDownModule, */
        NgxIntlTelInputModule,
        QRCodeModule,
        NgxMaskDirective,
        NgxMaskPipe,
        UiSwitchModule.forRoot({
            size: 'medium',
            // color: 'rgb(0, 189, 99)',
            // switchColor: '#80FFA2',
            // defaultBgColor: '#00ACFF',
            // defaultBoColor : '#476EFF',
            // checkedLabel: 'Si',
            // uncheckedLabel: 'No'
        }),
    ],
    // components that we want to make available
    exports: [
        // Components
        CodeInputComponent,
        ImgRoundComponent,
        PoweredByGiviComponent,
        PhoneInputComponent,
        AccountRegisterFormComponent,
        GoogleSigninCardComponent,
        AccountOtpVerifyComponent,
        SearchFilterComponent,
        PlayScratchComponent,
        ScratchBoxComponent,
        LuckyScratchLayoutComponent,
        LuckyScratchBoxComponent,
        LuckyPrizesPanelComponent,
        TicketsSelectorComponent,
        MarketTicketQuantityComponent,

        // list vertical
        SmartListStoreComponent,
        SmartListStoreWebComponent,
        SmartListUserPointComponent,
        SmartListUserTransactionComponent,
        SmartListUserTransactionFilterComponent,

        //gsa components
        GsaAccountInfoComponent,
        GsaGiviSkuModalComponent,

        SpinnerComponent,
        UserNavProfileComponent,

        // Directives
        InputFloatDirective,
        InputNumericDirective,
        // Modals
        AcceptGiviModalComponent,
        GiviExpressModalComponent,
        AssignedGiviModalComponent,
        LoginModalComponent,
        PurchaseWithPointsModalComponent,
        PurchaseGiftcardModalComponent,
        PurchaseProductModalComponent,
        PurchasePointsModalComponent,
        PurchaseTicketModalComponent,
        SendGiviComponent,
        SendGiviLinkComponent,
        SendGiviSmsComponent,
        SendPackageSmsComponent,
        SendGiviModalComponent,
        GeneralVideoModalComponent,
        GetPointsModalComponent,
        GiviNoteModalComponent,
        RedeemedSuccessComponent,
        AssignedStickerComponent,
        VerifyCardComponent,
        PackageBenefitDetailModalComponent,
        PurchasePackageModalComponent,
        CompleteRegisterAppComponent,
        VerifyAccountModalComponent,
        CommunityFormComponent,
        SendPackageComponent,
        SendPackageLinkComponent,
        DeleteTransactionComponent,
        TestModalComponent,

        //register
        RegisterAccountComponent,
        RegisterNewComponent,
        //forms
        RegisterAccountFormComponent,
        RegisterNewFormComponent,
        PanamaLobbyComponent,
        CostaRicaLobbyComponent,
        GiviScannerComponent,
        TruncatePipe,
        PaymentMethodComponent,
        StripeCardComponent,
        CardFormComponent,
        PackDetailsComponent,
        PopDetailsComponent,
        EventsDetailsComponent,
        CouponDetailsComponent,
        AssignedGiviComponent,
        SmartListCommunityVendorComponent,
        PurchaseCouponComponent,
        CouponQuantityComponent,
    ],
    providers: [
        // Api Services
        ApiBaseService,
        ApiAuthService,
        ApiAccountService,
        ApiPaymentGatewayService,
        ApiCustomerService,
        ApiPackageService,
        ApiLoyaltyPlanService,
        ApiScratchService,
        ApiVendorFormService,
        ApiTransactionService,
        ApiUploadService,
        ApiProductService,
        ApiMarketService,
        ApiCommunityService,
        // Shared
        SharedService,
        // Clases
        ComponentBase,
        PageBase,
        provideNgxMask()
    ],
})
export class SharedModule { }
